import React from 'react';
export default class CustomSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.default || this.props.options[0].value
        };
    }
    onChangeHandler(event) {
        this.setState({ value: event.target.value });
    }
    isValid() {
        return true;
    }
    render() {
        return (
            <div ref={this.props.customRef} className="custom-select">
                <label for={this.props.customRef}>{this.props.label}</label>
                <select
                    ref="select"
                    value={this.props.default}
                    onChange={this.onChangeHandler.bind(this)}
                >
                    {this.props.options.map(option => (
                        <option key={option.id} value={option.value}>
                            {option.text}
                        </option>
                    ))}
                </select>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/common/components/CustomSelect.jsx